<template>
	<div class="modal-body">
		<div class="row">
			<div class="col-sm-6">
				<span>Nome</span>
				<input
					type="text"
					v-model="data.uid.nome"
					class="form-control"
				/>
			</div>
			<div class="col-sm-6">
				<span>Sobrenome</span>
				<input
					type="text"
					v-model="data.uid.sobrenome"
					class="form-control"
				/>
			</div>

			<div class="col-sm-6">
				<span>Telefone</span>
				<input
					type="text"
					class="form-control"
					placeholder="(99) 99999-9999"
					v-model="data.uid.telefone"
					v-mask="'(##) #####-####'"
				/>
			</div>
			<div class="col-sm-6">
				<span>CPF</span>
				<input
					type="text"
					class="form-control"
					placeholder="999.999.999-99"
					v-model="data.uid.cpf"
					v-mask="'###.###.###-##'"
				/>
			</div>

			<div class="col-sm-6">
				<span>Departamento</span>
				<select class="form-control" v-model="dataIn.uid.departamento">
					<option
						v-for="(dep, index) in assets.departamentos"
						:key="index"
						:value="dep.cod"
					>
						{{ dep.titulo }}
					</option>
				</select>
			</div>
			<div class="col-sm-6">
				<span>Registro</span>
				<input
					type="text"
					v-model="data.uid.registro"
					class="form-control"
				/>
			</div>

			<div class="col-sm-6">
				<span>Função</span>
				<input
					type="text"
					v-model="data.uid.funcao"
					class="form-control"
				/>
			</div>
			<div class="col-sm-6">
				<span>Empresa</span>
				<input
					type="text"
					v-model="data.uid.empresa"
					class="form-control"
				/>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		inject: ['assets'],
		props: ['dataIn', 'page'],
		computed: {
			data() {
				return this.dataIn;
			},
			departamento: {
				get: function () {
					if (typeof this.data.uid.departamento == 'string') {
						return this.data.uid.departamento;
					} else {
						if (this.data.uid.departamento.cod != undefined) {
							return this.data.uid.departamento.cod;
						} else {
							return 1;
						}
					}
				},
				set: function (t) {
					this.data.uid.departamento = t;
				},
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/settings/users/modal/comumInfo.vue